import { createApiHandler } from './handler';

const massEmails = {
  apiClient: null,
  path: '/admin/mass-emails',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  /**
   * Search clients for custom audience
   */
  async searchClients(params = {}) {
    const queryParams = new URLSearchParams(params);
    const response = await this.apiClient.get(`${this.path}/search-clients?${queryParams.toString()}`);
    return response.data;
  },

  /**
   * Preview audience count before creating campaign
   */
  async preview(form) {
    const response = await this.apiClient.post(`${this.path}/preview`, form);
    return response.data;
  },

  /**
   * Send or schedule a campaign
   */
  async send(id, form = {}) {
    const response = await this.apiClient.post(`${this.path}/${id}/send`, form);
    return response.data;
  },

  /**
   * Cancel a scheduled campaign
   */
  async cancel(id) {
    const response = await this.apiClient.post(`${this.path}/${id}/cancel`);
    return response.data;
  },

  /**
   * Get campaign recipients
   */
  async getRecipients(id, params = {}) {
    const queryParams = new URLSearchParams(params);
    const response = await this.apiClient.get(`${this.path}/${id}/recipients?${queryParams.toString()}`);
    return response.data;
  },

  /**
   * Get campaign statistics
   */
  async getStatistics(id) {
    const response = await this.apiClient.get(`${this.path}/${id}/statistics`);
    return response.data;
  },
};

export default massEmails;
